<template>
    <div class="activeCode">
        <!-- isHorizontal ? 'horizontal' : 'vertical', -->
        <div class="windowView" :class="[themeName]">
            <div class="content">
                <h3 class="h3_c">{{ $pageLanguage.activeTitle }}</h3>
                <div class="input_user">
                    <input v-model="activateCode" type="text" :placeholder="$pageLanguage.codePlaceholder">
                </div>
                <div class="btn"><span @click="activeGame" class="red">{{ $pageLanguage.activeBtnText }}</span></div>
                <div class="btn" v-if="guidanceSwtich"><span @click="$router.push('/activeInstructions')" class="grey">{{buttonContent}}</span></div>
                <div class="out_link"><span @click="giveOutLink">{{urlContent}}</span></div>
            </div>
            <div v-if="themeName === 'baigui' || themeName === 'ssy'" class="bg">
                <div class="top_bg"></div>
                <div class="body_bg"></div>
                <div class="btm_bg"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'activeCode',
    data () {
        return {
            buttonContent: '',
            activateCode: '',
            appID: '',
            channelID: '',
            uid: '',
            guidanceSwtich: false,
            url: '',
            windowsContent: '',
            urlContent: '' // ,
            // isHorizontal: window.orientation === 90 || window.orientation === -90
        }
    },
    computed: {
        $pageLanguage () {
            return this.$language.page.activeCode
        },
        themeName () {
            // baigui: 百鬼 | ssy: 双生怨
            return this.$store.state.theme
        }
    },
    // created () {
    //     this.buttonContent = this.$pageLanguage.buttonContent
    //     this.urlContent = this.$pageLanguage.urlContent
    // },
    methods: {
        // 激活游戏
        activeGame () {
            if (!this.activateCode) return this.$Toast(this.$pageLanguage.codePlaceholder)
            this.$apis.verifyGameActivate({
                appID: this.appID,
                channelID: this.channelID,
                activateCode: this.activateCode,
                userID: this.uid
            }).then((res) => {
                if (res.state * 1 === 1) {
                    // this.$Toast('激活成功')
                    this.$Toast(this.$pageLanguage.activeSuccessMsg)
                    setTimeout(() => {
                        $jsBridge.call('web_activateSuccess', res => {
                        })
                    }, 1500)
                } else {
                    this.$Toast(res.msg)
                }
            })
        },
        // 给客户端外链
        giveOutLink () {
            $jsBridge.call('web_openOutsideLink', { url: this.url }, res => {
                console.log(res)
            })
        },
        getAllData () {
            this.$apis.getActivateOutterUrl({
                appID: this.appID,
                channelID: this.channelID,
                uid: this.uid
            }).then(res => {
                if (res.state * 1 === 1) {
                    this.buttonContent = res.data.buttonContent || this.$pageLanguage.buttonContent
                    this.guidanceSwtich = res.data.guidanceSwtich
                    this.url = res.data.url
                    this.urlContent = res.data.urlContent
                    localStorage.windowsContent = res.data.windowsContent
                }
            })
        }
    },
    beforeMount () {
        this.appID = this.$getCookies('EU-AppID')
        this.channelID = this.$getCookies('EU-ChannelID')
        this.uid = this.$getCookies('EU_Uid')
        this.getAllData()
    }
}
</script>
<style lang="less" scoped>
    // 默认皮肤样式
    .activeCode{
        width: 100%;
        height: 100%;
        position: relative;
        .windowView{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            margin: auto;
            background-color: rgba(32, 32, 35, .9);
            border-radius: .1rem;
            padding-bottom: .4rem;
            box-sizing: border-box;
            text-align: center;
            width: 6.38rem;
            .content {
                position: relative;
                z-index: 2;
            }
            .bg {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                .top_bg {
                    flex: none;
                    background-position: center bottom;
                    background-repeat: no-repeat;
                    background-size: 100% auto;
                }
                .body_bg {
                    flex: auto;
                    background-position: center center;
                    background-repeat: repeat-y;
                    background-size: 100% auto;
                }
                .btm_bg {
                    flex: none;
                    background-position: center top;
                    background-repeat: no-repeat;
                    background-size: 100% auto;
                }
            }
            // &.horizontal {
            //     width: 6.38rem;
            //     // height: auto;
            // }
            // &.vertical {
            //     width: 6.38rem;
            // }
            h3.h3_c{
                font-size: .5rem;
                color: #fff;
                line-height: 1.2rem;
                margin: 0;
                font-weight: 600;
            }
            .input_user{
                width: 5.64rem;
                margin: 0 auto;
                line-height: 0;
                input{
                    width: 100%;
                    box-sizing: border-box;
                    height: .8rem;
                    // border: 1px solid #979797;
                    border: none;
                    border-radius: .08rem;
                    padding: 0 .2rem;
                    font-size: .3rem;
                    outline: none;
                    line-height: .8rem;
                    color: #333;
                    overflow: hidden;
                    &::-webkit-input-placeholder, &::-moz-placeholder,  &::-ms-input-placeholder {
                        color: #b9aaa0;
                    }
                }
            }
            .btn{
                width: 5.64rem;
                margin: 0 auto;
                margin-top: .25rem;
                span{
                    display: block;
                    height: .8rem;
                    line-height: .8rem;
                    // width: 100%;
                    padding: 0px .45rem;
                    color: #fff;
                    font-size: .36rem;
                    text-align: center;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    border-radius: .08rem;
                    overflow: hidden;
                }
                span.red{
                    // background-color: #E62416;
                    background-image: url('../../assets/images/btn_bg_1.png');
                }
                span.grey{
                    // background-color: #636268;
                    background-image: url('../../assets/images/btn_bg_0.png');
                }
            }
            .out_link{
                text-align: center;
                line-height: 0;
                width: 5.64rem;
                margin: 0 auto;
                cursor: pointer;
                span{
                    font-size: .24rem;
                    color: #aaa;
                    margin-top: .05rem;
                    line-height: 2;
                }
            }
        }
    }
    // 引用定制皮肤 需要放在默认皮肤后面
    @import '../../theme/index.less';
</style>
